import React from "react";

export const SkipNextIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height="48" 
    width="48"
    viewBox="0 0 46 46"
    {...props}
    >
    <path d="M34 36V12h3v24Zm-23 0V12l17.3 12Zm3-12Zm0 6.25L23.05 24 14 17.75Z" />
  </svg>
);
